var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _path3, _rect6, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.2666,
    y: 0.5,
    width: 11.7333,
    height: 15,
    rx: 1.875,
    fill: "#2FB776"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2666 11.2148H15.9999V13.6256C15.9999 14.6611 15.1605 15.5006 14.1249 15.5006H6.1416C5.10607 15.5006 4.2666 14.6611 4.2666 13.6256V11.2148Z",
    fill: "url(#paint0_linear_1106_36468)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.59961,
    y: 8,
    width: 6.4,
    height: 3.21429,
    fill: "#229C5B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.59961,
    y: 3.71484,
    width: 6.4,
    height: 4.28571,
    fill: "#27AE68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2666 2.375C4.2666 1.33947 5.10607 0.5 6.1416 0.5H9.59994V3.71429H4.2666V2.375Z",
    fill: "#1D854F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.2666,
    y: 3.71484,
    width: 5.33333,
    height: 4.28571,
    fill: "#197B43"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.2666,
    y: 8,
    width: 5.33333,
    height: 3.21429,
    fill: "#1B5B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2666 6.38151C4.2666 4.90875 5.46051 3.71484 6.93327 3.71484C8.40603 3.71484 9.59994 4.90875 9.59994 6.38151V10.5452C9.59994 12.0985 8.34074 13.3577 6.78744 13.3577H4.2666V6.38151Z",
    fill: "black",
    fillOpacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 3.71484,
    width: 8.53333,
    height: 8.57143,
    rx: 1.875,
    fill: "url(#paint1_linear_1106_36468)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5L5.23883 7.95L6.92268 5.5H5.54811L4.50859 7.06429L3.48625 5.5H2.06873L3.76117 7.95L2 10.5H3.37457L4.48282 8.84286L5.58247 10.5H7Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1106_36468",
    x1: 4.2666,
    y1: 13.3577,
    x2: 15.9999,
    y2: 13.3577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#163C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1106_36468",
    x1: 0,
    y1: 8.00056,
    x2: 8.53333,
    y2: 8.00056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176F3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.24bd3de5d22ed49db3c973fcb176130b.svg";
export { ForwardRef as ReactComponent };